import { useMemo } from 'react';

import EditorStore from 'Tiptap/stores/EditorStore';

let editorStoreInstance: EditorStore | null = null;

export function useEditorStore(): EditorStore {
  const store = useMemo(() => {
    if (!editorStoreInstance) {
      editorStoreInstance = new EditorStore();
    }
    return editorStoreInstance;
  }, []);

  return store;
}

export function resetEditorStore(): void {
  if (editorStoreInstance) {
    editorStoreInstance.reset();
  }
}
